import { Button as ChakraButton } from 'src/theme'

export default function Button (props) {
  return <ChakraButton
    colorScheme={'purple'}
    // font-family: Shapiro, sans-serif;
    fontWeight='700'
    fontSize='11px'
    letterSpacing='2.2px'
    lineHeight='13px'
    textTransform='uppercase'
    position='relative'
    display='flex'
    justifyContent='center'
    alignItems='center'
    m='0px'
    p='8px 16px'
    color='rgb(255, 255, 255)'
    cursor='pointer'
    backgroundColor='rgb(50, 94, 255)'
    border='2px solid rgb(50, 94, 255)'
    width="full"
    _hover={{
      color: 'rgb(255, 255, 255)',
      backgroundColor: 'rgb(24, 63, 205)',
      borderColor: 'rgb(24, 63, 205)',
    }}
    _active={{
      color: 'rgb(255, 255, 255)',
      backgroundColor: 'rgb(50, 94, 255)',
      borderColor: 'rgb(50, 94, 255)',
    }}
    borderRadius={0}
    {...props}
  />
}
